import styled from 'styled-components';
import { inputPlaceholder } from '../../../../helpers/style-helpers';

export const AlertsFormSC = styled.div`
  .af-subject,
  .af-title {
    margin-bottom: 20px;
  }

  .af-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;

    h2 {
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: rgba(46, 43, 95, 0.6);
    }
  }

  .af-header-tab-col {
    width: 60%;
  }

  .af-bottom {
    margin-top: 24px;
  }
`;

type TAAlertsTextareaSC = {
  lineHeight: number;
};
export const AlertsTextareaSC = styled.textarea<TAAlertsTextareaSC>`
  ${inputPlaceholder('rgba(34, 32, 89, 0.4)')}

  width: 100%;
  border: none;
  border-bottom: 1px solid rgba(51, 61, 108, 0.4);
  resize: none;
  font-size: 24px;
  line-height: ${({ lineHeight }) => `${lineHeight}px`};
  padding-bottom: 12px;

  &:focus,
  &:active,
  &:hover {
    border-bottom: 1px solid rgba(51, 61, 108, 1);
    outline: none;
    box-shadow: none;
  }
`;

export const AlertFormPreviewSC = styled.div`
  .afp-body {
    margin-bottom: 24px;
    overflow-wrap: break-word;
  }

  .doc-name {
    font-size: 14px;
    font-weight: 600;
  }

  .afp-notice {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 24px;
    color: rgba(24, 30, 52, 0.6);
  }
`;

export const AlertSuccessSC = styled.div`
  p {
    margin-top: 30px;
    color: rgba(46, 43, 95, 0.4);

    b {
      font-weight: 600;
      color: #1b203d;
    }
  }
`;
